module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_6000.4319919a.png";